import { Fragment } from 'react'
import { Box, BoxProps, Container, Divider, Grid, Link, Stack, Typography } from '@mui/material'
import parse from 'html-react-parser'

import { useAppStore } from '@/contexts/store'

const LandingFooter = (props: BoxProps) => {
  const { menu, strings } = useAppStore()

  return (
    <Box component="footer" {...props}>
      <Container>
        <Grid container gap={4}>
          <Grid size={{ xs: 4, sm: 8, md: 12 }}>
            <Divider />
          </Grid>

          <Stack
            component={Grid}
            direction="row"
            alignItems="baseline"
            justifyContent="center"
            flexWrap="wrap"
            gap="0.4rem"
            size={{ xs: 4, sm: 8, md: 12 }}
            sx={{ pb: { xs: 2, sm: 4 } }}
          >
            {strings?.footer?.copyright ? (
              <Typography
                component="span"
                variant="textSmall"
                color="text.secondary"
                sx={{
                  '& a': { color: (theme) => theme.palette.text.secondary }
                }}
              >
                {parse(strings?.footer?.copyright || '')}
              </Typography>
            ) : null}

            {menu?.legals_menu?.menu?.map(({ title, url, target }, index) => (
              <Fragment key={`legal-${index}`}>
                <Typography component="span" variant="textSmall" color="text.secondary">
                  ·
                </Typography>
                <Link href={url} target={target} color="text.secondary">
                  <Typography component="span" variant="textSmall">
                    {title}
                  </Typography>
                </Link>
              </Fragment>
            ))}
          </Stack>
        </Grid>
      </Container>
    </Box>
  )
}

export default LandingFooter
